import React from 'react';
import AlertExecution from '@app/model/alert/AlertExecution';
import PriceComparisonAlertExecutionNotificationRowFragment
	from '@app/site/secured/rateshopper/rates/alert-execution/fragment/price-comparison/PriceComparisonAlertExecutionNotificationRowFragment';
import PriceComparisonAlertExecutionNotificationOutput
	from '@app/model/alert/output/PriceComparisonAlertExecutionNotificationOutput';
import PriceComparisonAlertRulePricePoint from '@app/model/alert/PriceComparisonAlertRulePricePoint';

const PriceComparisonAlertExecutionUpdatedNotificationsFragment: React.FunctionComponent<{
	alertExecution: AlertExecution,
	notificationOutputs: PriceComparisonAlertExecutionNotificationOutput[],
	marketStateDetailsModal: any
}>
	= ({ alertExecution, notificationOutputs, marketStateDetailsModal }) => {
	return <section className="mt-8 rounded-xl border border-gray-200 bg-white p-6 shadow-sm sm:p-8">
		<div>
			<div className="flex items-center justify-between">
				<h2 className="text-base font-semibold leading-6 text-gray-950">
					Updates Since Previous Run
				</h2>
			</div>
			<div className="mt-5 flow-root">
				<div className="overflow-x-auto">
					<div className="inline-block min-w-full align-middle">
						<table className="min-w-full divide-y divide-gray-300 text-gray-500">
							<thead>
							<tr>
								<th scope="col"
									className="whitespace-nowrap py-3 pl-0 pr-3 text-left text-xs font-semibold text-gray-950">Date
								</th>
								<th scope="col"
									className="whitespace-nowrap px-2 py-3 text-left text-xs font-semibold text-gray-950">
									Your Price
								</th>
								<th scope="col"
									className="whitespace-nowrap px-2 py-3 text-left text-xs font-semibold text-gray-950">
									{alertExecution.alertOutput.priceComparisonAlertRule.pricePoint === PriceComparisonAlertRulePricePoint.MEDIAN && 'Median'}
									{alertExecution.alertOutput.priceComparisonAlertRule.pricePoint === PriceComparisonAlertRulePricePoint.MIN && 'Least Expensive'}
									{alertExecution.alertOutput.priceComparisonAlertRule.pricePoint === PriceComparisonAlertRulePricePoint.MAX && 'Most Expensive'}
								</th>
								{alertExecution.alertOutput.priceComparisonAlertRule.pricePoint !== PriceComparisonAlertRulePricePoint.MEDIAN && <th scope="col"
									className="whitespace-nowrap px-2 py-3 text-left text-xs font-semibold text-gray-950">
									Competitor
								</th>}
								<th scope="col"
									className="whitespace-nowrap px-2 py-3 text-left text-xs font-semibold text-gray-950">
									Change Since Last Run
								</th>
							</tr>
							</thead>
							<tbody className="divide-y divide-gray-200 bg-white">
							{notificationOutputs.map((notificationOutput) =>
								<PriceComparisonAlertExecutionNotificationRowFragment
									key={notificationOutput.current.id}
									notificationOutput={notificationOutput}
									alertExecution={alertExecution}
									marketStateDetailsModal={marketStateDetailsModal}
									showPreviousRun />)}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	</section>;
};

export default PriceComparisonAlertExecutionUpdatedNotificationsFragment;
